import {
    FETCHED_MENUS,
    FETCHED_MENU_ITEMS,
    FETCHED_MENU_CLASSES
} from './types';
import update from 'immutability-helper';
import {getTreeFromFlatData} from "react-sortable-tree";

const INITIAL_STATE = {
    all: [],
    menuClasses: [],
    menuItemsTreeData: [],
    touched: false,
};

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {

        case FETCHED_MENUS:

            return update(state, {
                all: {$set: action.menus},
            });

        case FETCHED_MENU_ITEMS:

            let menuItemsTreeData = getTreeFromFlatData({
                flatData: action.payload.data.map(node => ({
                    ...node,
                    name: node.name,
                    is_visible: node.is_visible,
                    new: node.new,
                    deleted: node.deleted,
                    clickable: node.clickable,
                    page_id: node.page_id,
                    css_class: node.css_class,
                    href: node.href,
                    expanded: node.expanded,
                    type: node.type,
                    page_title: node.page_title,
                })),
                getKey: node => node.id,
                getParentKey: node => node.parent,
                rootKey: null,
            });

            return update(state, {
                menuItemsTreeData: {$set: menuItemsTreeData},
                touched: {$set: action.payload.touched}
            });

        case FETCHED_MENU_CLASSES:

            return update(state, {
                menuClasses: {$set: action.menuClasses},
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/menus/reducer.js